<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>{{ 'MARKET_NOTIFICATIONS.TITLE' | translate }}</glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="'MARKET_NOTIFICATIONS.BACK' | translate"
        [previousPageUrl]="'/customize-design'"
        [useHistory]="true"
        [historyBackButtonTitle]="'COMMON.ACTION_LABELS.BACK' | translate"
      ></glxy-page-nav-button>
    </glxy-page-nav>
  </glxy-page-toolbar>
  <glxy-page-wrapper [maxWidth]="1160">
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          {{ 'MARKET_NOTIFICATIONS.MESSAGE_TITLE' | translate }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        {{ 'MARKET_NOTIFICATIONS.MESSAGE_SUBTITLE' | translate }}
        <div class="bulk-update-notice">
          <div [innerHTML]="'MARKET_NOTIFICATIONS.BULK_UPDATE_NOTICE' | translate"></div>
          <a class="bulk-update-link" [routerLink]="'/bc-admin/users/bulk-update'">
            {{ 'MARKET_NOTIFICATIONS.BULK_UPDATE' | translate }}
          </a>
        </div>
      </mat-card-content>
    </mat-card>
    <glxy-alert
      *ngIf="(this.partnerNotificationEnabled$ | async) === false"
      type="warning"
      [solidColor]="false"
      [actionTitle]="'MARKET_NOTIFICATIONS.GO_TO_CUSTOMIZE' | translate"
      [actionRouterLink]="'/customize-business-app/notifications'"
      [showAction]="true"
    >
      <span [innerHTML]="'MARKET_NOTIFICATIONS.ALL_NOTIFICATIONS_DISABLED' | translate"></span>
    </glxy-alert>
    <div class="table-container mat-elevation-z0">
      <div class="table-header">
        <va-search-box class="search" (update)="search($event)"></va-search-box>
      </div>
      <table mat-table [dataSource]="markets$" [trackBy]="trackById">
        <!-- Name -->
        <ng-container matColumnDef="name">
          <tr *matHeaderCellDef></tr>
          <td mat-cell *matCellDef="let row">
            <div class="company-name" *ngIf="row.market_id !== ''">
              {{ row.name }}
            </div>
            <div class="market-global-notification" *ngIf="row.market_id === ''">
              {{ row.name }}
              <mat-icon
                [glxyTooltip]="'MARKET_NOTIFICATIONS.GLOBAL_SETTING_TOOLTIP' | translate"
                [tooltipPositions]="positions"
              >
                help_outline
              </mat-icon>
            </div>
          </td>
        </ng-container>

        <!-- Expanded indicator -->
        <ng-container matColumnDef="indicator">
          <th mat-header-cell *matHeaderCellDef class="actions-header"></th>
          <td mat-cell class="subtitle toggle-container" *matCellDef="let row">
            <mat-icon [@indicatorRotate]="getExpandedState(row.market_id)" class="toggle-table">
              keyboard_arrow_down
            </mat-icon>
          </td>
        </ng-container>

        <!-- Data -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="element-row"
          [appDetailRow]="row"
          [appDetailRowTpl]="tpl"
          (opened)="panelOpen(row.market_id)"
          (closed)="panelClose(row.market_id)"
        ></tr>
      </table>
      <div class="table-information" *ngIf="!!!(markets$ | async)">
        <mat-spinner [strokeWidth]="6" [diameter]="48"></mat-spinner>
      </div>
      <div class="table-footer"></div>
    </div>
  </glxy-page-wrapper>
</glxy-page>

<ng-template #tpl let-element>
  <tr class="notifications-row" [@detailExpand]>
    <td colspan="2">
      <app-legacy-notification-preference
        [partnerId]="partnerId"
        [marketId]="element.market_id"
      ></app-legacy-notification-preference>
    </td>
  </tr>
</ng-template>
